import { formatAddress, formatPhoneNumber } from '@/components/shared/utils/utils';
import { ContactInfoProps } from '../Applicant.types';
import { ApplicantInfoCard, ApplicantInfoRow } from './ApplicantInfoCard';

export const ContactInformation = ({
    physicalAddress,
    mailingAddress,
    businessPhone,
    businessPhoneExtension,
    businessEmail,
}: ContactInfoProps) => {
    return (
        <ApplicantInfoCard title="Contact Information">
            {physicalAddress && (
                <ApplicantInfoRow
                    label="Physical Address"
                    value={formatAddress({
                        ...physicalAddress,
                        state: physicalAddress?.stateOrTerritory,
                    })}
                    data-testid="physical-address"
                />
            )}
            <ApplicantInfoRow
                label="Mailing Address"
                value={formatAddress({
                    ...mailingAddress,
                    state: mailingAddress?.stateOrTerritory,
                })}
                data-testid="contact-mailing-address"
            />

            <ApplicantInfoRow
                label="Business Phone"
                value={formatPhoneNumber(businessPhone)}
                key="businessPhone"
                data-testid="businessPhone"
            />
            <ApplicantInfoRow
                label="Extension"
                value={businessPhoneExtension}
                data-testid="businessPhoneExtension"
            />
            <ApplicantInfoRow
                label="Business Email"
                value={businessEmail}
                data-testid="businessEmail"
            />
        </ApplicantInfoCard>
    );
};
